import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["itemType"];
import React from 'react';
import * as Material from '@mui/material';
import { MoreVert } from '@mui/icons-material';
Material.Card;
// type ComponentListKeys = RemoveMui<keyof ComponentsPropsList>
function isBuilderArray(items) {
    return Boolean(items === null || items === void 0 ? void 0 : items.length);
}
var renderItems = function (items) {
    return items === null || items === void 0 ? void 0 : items.map(function (el) {
        if (!el || el.hidden)
            return null;
        var itemType = el.itemType, props = _objectWithoutProperties(el, _excluded);
        var Element = Material[itemType];
        if (Array.isArray(props.children) && props.children.length) {
            props.children = renderItems(props.children);
        }
        return /*#__PURE__*/ React.createElement(Element, props);
    });
};
var data = [{
        "RegNo": "MH12AB1234",
        "VehicleType": "Car",
        "Brand": "Maruti Suzuki",
        "Model": "Swift",
        "Customer": "Rajesh Kumar",
        "YearOfManufacture": 2019,
        "ServiceDate": "2025-03-30",
        "ServiceTime": "10:00 AM",
        "Branch": "Maruti Service Center, Pune",
        "Mobile": "+91-9876543210",
        "Status": "Under Service"
    }, {
        "RegNo": "KA03CD5678",
        "VehicleType": "Bike",
        "Brand": "Royal Enfield",
        "Model": "Classic 350",
        "Customer": "Anil Patil",
        "YearOfManufacture": 2021,
        "ServiceDate": "2025-04-01",
        "ServiceTime": "11:30 AM",
        "Branch": "Royal Enfield Service Hub, Bangalore",
        "Mobile": "+91-8765432109",
        "Status": "Active"
    }, {
        "RegNo": "DL05EF9101",
        "VehicleType": "SUV",
        "Brand": "Hyundai",
        "Model": "Creta",
        "Customer": "Pooja Sharma",
        "YearOfManufacture": 2020,
        "ServiceDate": "2025-04-05",
        "ServiceTime": "2:00 PM",
        "Branch": "Hyundai Service Center, Delhi",
        "Mobile": "+91-7654321098",
        "Status": "Active"
    }, {
        "RegNo": "TN10GH2345",
        "VehicleType": "Truck",
        "Brand": "Tata",
        "Model": "Ultra",
        "Customer": "Srinivasan Iyer",
        "YearOfManufacture": 2018,
        "ServiceDate": "2025-04-03",
        "ServiceTime": "4:00 PM",
        "Branch": "Tata Service Depot, Chennai",
        "Mobile": "+91-6543210987",
        "Status": "Under Service"
    }, {
        "RegNo": "GJ18IJ6789",
        "VehicleType": "Van",
        "Brand": "Mahindra",
        "Model": "Bolero",
        "Customer": "Nikita Desai",
        "YearOfManufacture": 2017,
        "ServiceDate": "2025-03-29",
        "ServiceTime": "9:30 AM",
        "Branch": "Mahindra Service Center, Ahmedabad",
        "Mobile": "+91-5432109876",
        "Status": "Inactive"
    }, {
        "RegNo": "AP09KL1122",
        "VehicleType": "Car",
        "Brand": "Honda",
        "Model": "City",
        "Customer": "Arun Reddy",
        "YearOfManufacture": 2022,
        "ServiceDate": "2025-04-02",
        "ServiceTime": "12:00 PM",
        "Branch": "Honda Service Center, Hyderabad",
        "Mobile": "+91-4321098765",
        "Status": "Active"
    }, {
        "RegNo": "RJ27MN3344",
        "VehicleType": "Bike",
        "Brand": "Bajaj",
        "Model": "Pulsar 150",
        "Customer": "Devendra Singh",
        "YearOfManufacture": 2019,
        "ServiceDate": "2025-03-31",
        "ServiceTime": "1:00 PM",
        "Branch": "Bajaj Service Center, Jaipur",
        "Mobile": "+91-3210987654",
        "Status": "Active"
    }, {
        "RegNo": "WB22OP5566",
        "VehicleType": "Scooter",
        "Brand": "TVS",
        "Model": "Jupiter",
        "Customer": "Soma Ghosh",
        "YearOfManufacture": 2020,
        "ServiceDate": "2025-04-06",
        "ServiceTime": "3:30 PM",
        "Branch": "TVS Service Hub, Kolkata",
        "Mobile": "+91-2109876543",
        "Status": "Active"
    }, {
        "RegNo": "UP14QR7788",
        "VehicleType": "Car",
        "Brand": "Toyota",
        "Model": "Innova Crysta",
        "Customer": "Vikram Yadav",
        "YearOfManufacture": 2016,
        "ServiceDate": "2025-04-04",
        "ServiceTime": "11:00 AM",
        "Branch": "Toyota Service Center, Lucknow",
        "Mobile": "+91-1098765432",
        "Status": "Inactive"
    }];
export default function JsonRenderer() {
    var items = [{
            itemType: 'Grid',
            container: true,
            p: 3,
            spacing: 2,
            children: data.map(function (it) { return ({
                itemType: 'Grid',
                item: true,
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3,
                children: [{
                        itemType: 'Card',
                        variant: 'outlined',
                        children: [{
                                itemType: 'Stack',
                                direction: 'row',
                                justifyContent: 'space-between',
                                children: [{
                                        itemType: 'Box',
                                        children: [{
                                                itemType: 'Typography',
                                                children: it.RegNo,
                                                fontWeight: 'strong'
                                            }, {
                                                itemType: 'Typography',
                                                children: "".concat(it.Brand, " ").concat(it.Model, " | ").concat(it.VehicleType),
                                                fontSize: 'sm',
                                                fontWeight: 'medium',
                                                color: 'text.secondary'
                                            }]
                                    }, {
                                        itemType: 'Box',
                                        children: [{
                                                itemType: 'Chip',
                                                label: it.Status,
                                                variant: 'filled',
                                                color: 'info',
                                                size: 'small',
                                                shape: 'rounded'
                                            }, {
                                                itemType: 'IconButton',
                                                children: /*#__PURE__*/ React.createElement(MoreVert, {
                                                    color: "secondary"
                                                }),
                                                size: 'small',
                                                edge: 'end'
                                            }]
                                    }]
                            }, {
                                itemType: 'Card',
                                variant: 'outlined',
                                sx: {
                                    p: {
                                        xs: 1,
                                        sm: 1
                                    },
                                    bgcolor: 'background.secondary',
                                    mt: 1,
                                    border: 0
                                },
                                children: [{
                                        itemType: 'Stack',
                                        direction: 'row',
                                        justifyContent: 'space-between',
                                        children: [{
                                                itemType: 'Typography',
                                                children: 'Service date:',
                                                color: 'text.secondary'
                                            }, {
                                                itemType: 'Typography',
                                                children: it.ServiceDate,
                                                fontWeight: 'medium'
                                            }]
                                    }, {
                                        itemType: 'Stack',
                                        direction: 'row',
                                        justifyContent: 'space-between',
                                        children: [{
                                                itemType: 'Typography',
                                                children: 'Service time:',
                                                color: 'text.secondary'
                                            }, {
                                                itemType: 'Typography',
                                                children: it.ServiceTime,
                                                fontWeight: 'medium'
                                            }]
                                    }, {
                                        itemType: 'Stack',
                                        direction: 'row',
                                        justifyContent: 'space-between',
                                        columnGap: 2,
                                        children: [{
                                                itemType: 'Typography',
                                                children: 'Branch:',
                                                color: 'text.secondary'
                                            }, {
                                                itemType: 'Typography',
                                                children: it.Branch,
                                                fontWeight: 'medium',
                                                align: 'right',
                                                noWrap: true
                                            }]
                                    }, {
                                        itemType: 'Stack',
                                        direction: 'row',
                                        justifyContent: 'space-between',
                                        columnGap: 2,
                                        children: [{
                                                itemType: 'Typography',
                                                children: 'Customer:',
                                                color: 'text.secondary'
                                            }, {
                                                itemType: 'Typography',
                                                children: it.Customer,
                                                fontWeight: 'medium',
                                                align: 'right',
                                                noWrap: true
                                            }]
                                    }]
                            }]
                    }]
            }); })
        }];
    return renderItems(items);
}
